import {
  BigWinControllerFg,
  SlotAnimationConstant,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist";
import { gameConstants } from "../Constants/gameConstants";
import { delayedCall, dispatcher, ingenuity, killDelayedCall, Linear, SpineBase } from "@quest/base-core";
import { SlotEventConstants } from "@quest/slot-core";
export class BigWinControllerFgGame extends BigWinControllerFg {
  protected characterSpine: SpineBase;

  protected initializeFSBigWinElements(): void {
    super.initializeFSBigWinElements();
    this.characterSpine = this.view.getSpineById("fgBigwinCharacter");
  }
  /**
   * overrided to change game flow from behavior
   */
  protected startFSBigWin(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_IN_SOUND, {
      id: SoundConstant.FREGAME_BGLOOP,
      vol: 0.3,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    //  To add bottom bar on top
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BOTTOM_BAR_ON_TOP, this);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREE_GAME_WIN_METER);
    this.model.setIsBigWinRunning(true);
    dispatcher.fireEvent(SlotEventConstants.FG_DISABLED_ALL_BUTTONS);
    this.freeSpinBigWinMeter.visible = false;
    this.freeSpinBigWinMeter.setCurrencyFormattedValue(gameConstants.FG_TICKUP_START_COUNT.toString());
    this.playFgSpineInLoop();
    this.playFgCharacterSpineInLoop();
    !ingenuity.deviceEnv.isDesktop && this.playFgPortraitSpineInLoop();
    this.showFSBigWinTickup();
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    this.addFSBigWinOnTop();
    this.createMask();
  }
  /**
   * overrided to stop stopFgSpineInLoop call
   */
  protected freeSpinBigWinPresentationComplete() {
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.WIN_SOUND_FG_3, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
    dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_OUT_SOUND, { id: SoundConstant.FREGAME_BGLOOP, vol: 1, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
    delayedCall(SlotConstantsBehavior.FS_BIG_WIN_METER_MOVE_DELAY, SlotConstantsBehavior.DURATION_1200, () => {
      killDelayedCall(SlotConstantsBehavior.FS_BIG_WIN_METER_MOVE_DELAY);
      this.moveFSBigWinMeterInLeft();
      !ingenuity.deviceEnv.isDesktop && this.stopFgPortraitSpineInLoop();
    }, this);
  }
  /**
   * override to eliminate the counter moving logic
   */
  protected moveFSBigWinMeterInLeft() {
    const alphatween = ingenuity.currentGame.add.tween(this.freeSpinBigWinMainContainer).to({ alpha: 0 }, 500, Linear.None, true, 0, 0, false);
    alphatween.onComplete.addOnce(() => {
      alphatween.stop();
      ingenuity.currentGame.tweens.remove(alphatween);
      this.freeSpinBigWinHide();
      this.resetFSBigWinElements();
      this.stopFSBigWinAndTicker();
    }, this);
  }
  /**to play smoke animation behind character */
  protected playFgSpineInLoop(): void {
    this.freeSpinBigWinMainContainer.alpha = 1;
    this.fgLoopSpine.setPause(false);
    this.fgLoopSpine.visible = true;
    this.fgLoopSpine.playAnim(gameConstants.FG_BIG_WIN_BG_SMOKE, false);
    this.fgLoopSpine.onComplete.addOnce(() => {
      this.fgLoopSpine.playAnim(gameConstants.FG_BIG_WIN_BG_SMOKE_LOOP, true);
    }, this);
  }
  /**to play character spine aniamtion in and Loop */
  protected playFgCharacterSpineInLoop(): void {
    this.characterSpine.setPause(false);
    this.characterSpine.visible = true;
    this.characterSpine.playAnim(SlotAnimationConstant.FG_BIG_WIN_DESKTOP_START, false);
    this.characterSpine.onComplete.addOnce(() => {
      this.characterSpine.playAnim(SlotAnimationConstant.FG_BIG_WIN_DESKTOP_LOOP, true);
    }, this);
  }
  /**
   * overrided to avoid on complaete logic for code
   */
  protected stopFgSpineInLoop(): void {
    this.fgLoopSpine.visible = false;
    this.fgLoopSpine.setPause(true);
    this.fgLoopSpine.onComplete.dispose();
    this.characterSpine.visible = false;
    this.characterSpine.setPause(true);
    this.characterSpine.onComplete.dispose();
  }
  /**
   * to avoid foreground animation as now we use desktop animation in portrait for character
   */
  protected stopFgPortraitSpineInLoop(): void {
    //
  }
}
